import React, {useState, useEffect, useMemo, useCallback} from 'react'
import {useIntl} from 'react-intl'
import {KTCard, KTCardBody, Table, Loading} from '../../../components'
import {CustomCell} from '../../../components/Table/columns/CustomCell'
import {CustomHeader} from '../../../components/Table/columns/CustomHeader'
import {ListHeader} from '../../../components/Table/header/ListHeader'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'

import {useDispatch, useSelector} from 'react-redux'
import {blockGetAll, blockExcel} from '../../../redux/slices/project.slice'

import {pagination} from '../../../helpers'

import {
  useMemoizedStaticData
} from '../../../utils/performanceOptimizations'

const selectBlockData = (state) => ({
  block: state.project.block,
  loading: state.project.loading
})

function List() {
  const intl = useIntl()
  const {block, loading} = useSelector(selectBlockData)
  const dispatch = useDispatch()

  const [params, setParams] = useState(pagination)

  useEffect(() => {
    dispatch(blockGetAll(params))
  }, [dispatch, params])

  const handleSorting = useCallback((item) => {
    setParams((prevState) => ({...prevState, sort: item && item.sort, order: item && item.order}))
  }, [])

  const handleSearch = useCallback((item) => {
    setParams((prevState) => ({...prevState, name: item}))
  }, [])

  const handlePagination = useCallback((pagination) => {
    setParams((prevState) => ({...prevState, ...pagination}))
  }, [])

  const handleExcelExport = useCallback(() => {
    dispatch(
      blockExcel({
        params,
        fileName: intl.formatMessage({id: 'BC.BLOCK'}),
      })
    )
  }, [dispatch, params, intl])

  const columns = useMemo(() => [
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'BLOCK.SEARCH.NAME'})}
          className='min-w-125px'
        />
      ),
      accessor: 'name',
      Cell: ({...props}) => <CustomCell item={props} />,
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'BLOCK.SEARCH.CONSTRUCTIONSITENAME'})}
          className='min-w-125px'
        />
      ),
      accessor: 'constructionSiteName',
      Cell: ({...props}) => <CustomCell item={props} />,
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'BLOCK.SEARCH.DESCRIPTION'})}
          className='min-w-125px'
        />
      ),
      accessor: 'description',
      Cell: ({...props}) => <CustomCell item={props} />,
    },
  ], [intl, handleSorting])

  const actionButtons = useMemoizedStaticData(() => [
    {
      title: 'BUTTON.EXCEL',
      onClick: handleExcelExport,
      icon: '/images/icons/duotune/arrows/arr044.svg',
      variant: 'light-primary',
    },
  ], [handleExcelExport])

  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'BC.BLOCK'})}</PageTitle>
      <KTCard>
        <ListHeader
          search={handleSearch}
          actionButtons={actionButtons}
        />
        <KTCardBody>
          {!block && <ListLoading />}
          {block && (
            <Table
              items={block}
              cols={columns}
              handlePagination={handlePagination}
              paddless
            />
          )}
        </KTCardBody>
      </KTCard>

      {loading && <Loading />}
    </>
  )
}
export {List}
